export const INTEGRATION_WEBHOOKS_PATH = '/business/commerce/integration-webhooks';
export const INTEGRATION_WEBHOOKS_TITLE = 'Webhooks';

export const integrationWebhooksUrl = (commerceId: string) =>
  `${INTEGRATION_WEBHOOKS_PATH}?commerceId=${commerceId}`;
